import { Box, Flex } from '@chakra-ui/react';

export const CaseStudyBackground = () => {
  return (
    <Box position="relative" width="100%" height="100%">
      <Flex position="absolute" w="100%" h="100%" backgroundColor="purple.50" opacity="1" zIndex={-1} />
    </Box>
  );
};
